var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.694 35.694",
    enableBackground: "new 0 0 35.694 35.694",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#CC0000",
    strokeWidth: 1.6944,
    strokeMiterlimit: 10,
    cx: 17.847,
    cy: 17.847,
    r: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC0000",
    d: "M11.349,23.038c-0.007-0.556,0.37-0.902,0.71-1.251c1.206-1.233,2.421-2.457,3.646-3.671 c0.228-0.226,0.24-0.364,0.005-0.596c-1.189-1.169-2.362-2.354-3.54-3.534c-0.123-0.123-0.25-0.243-0.366-0.372 c-0.51-0.571-0.511-1.285-0.006-1.794c0.505-0.509,1.237-0.529,1.79-0.004c0.735,0.699,1.443,1.428,2.161,2.144 c0.575,0.573,1.161,1.136,1.717,1.727c0.245,0.26,0.399,0.271,0.658,0.008c1.249-1.273,2.517-2.527,3.778-3.787 c0.259-0.259,0.525-0.5,0.913-0.546c0.563-0.066,1.06,0.191,1.339,0.7c0.262,0.48,0.197,1.04-0.23,1.481 c-0.735,0.759-1.493,1.496-2.245,2.239c-0.608,0.6-1.216,1.201-1.836,1.789c-0.198,0.188-0.176,0.317,0.01,0.497 c1.008,0.978,2.007,1.965,3.008,2.95c0.382,0.376,0.771,0.745,1.136,1.137c0.487,0.523,0.457,1.251-0.048,1.757 c-0.539,0.54-1.248,0.581-1.782,0.058c-1.345-1.32-2.683-2.648-4-3.996c-0.305-0.312-0.472-0.272-0.751,0.018 c-1.162,1.212-2.346,2.403-3.525,3.6c-0.163,0.165-0.325,0.335-0.509,0.473c-0.388,0.293-0.818,0.377-1.264,0.143 C11.652,23.962,11.361,23.588,11.349,23.038z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.3a0c6e8cb2a1a4e3749020a69cb67f6b.svg";
export { ForwardRef as ReactComponent };